import * as Yup from "yup";

export const ValidationSchema = (t: any) =>
    Yup.object().shape({
        title: Yup.string().required("Title is required!").min(1).max(128),
        tags: Yup.array().required("Tag Name is required!"),
        description: Yup.string().required("Description is required!").min(1),
    });
